export default __webpack_public_path__ + "static/media/gallery-wip-neck-rib_04.0c0e2400.jpg";